import React from 'react';
import styles from "./OnboardingCard.module.css"
import AssetsPack from '../../../../../../util/AssetsPack';

interface OnboardingCardProps extends React.HTMLAttributes<HTMLDivElement> {
    timer: number,
    onClose: () => void
}

const OnboardingCard: React.FC<OnboardingCardProps> = ({ timer, onClose, ...divProps }) => {
    return (
        <div
            {...divProps}
            className={`${styles["jap-container-card-main"]}${divProps.className ? ` ${divProps.className}` : ""}`}
        >
            <div className={styles["jap-header-container"]}>
                <div className={styles["jap-container-heading-pill-gradient-outer"]}>
                    <div className={styles["jap-container-heading-pill-inner"]}>
                        <div className={styles["jap-heading-icon-container"]}>
                            <img src={AssetsPack.icons.ICON_JOKER_AI.default} />
                        </div>
                        <p>JokerAi <span style={{ fontWeight: 600 }}>Pocket</span></p>
                        <span style={{ color: "#a4aefb" }}>|</span>
                        <p>Dismissing {timer} secs</p>
                        <img className={styles["jap-icon-close"]} src={AssetsPack.icons.ICON_CLOSE.default} alt="" onClick={onClose} />
                    </div>
                </div>
                <div className={styles["jap-introcard-divider"]}></div>
            </div>

            <div className={styles["jap-container-inner-scroll"]}>
                <div className={styles["jap-container-introcards"]}>
                    <div className={styles["jap-introcard"]}>
                        <img className={styles["jap-introcard-image"]} src={AssetsPack.images.JAP_INTRO_CARD_01.main.default} alt="" />
                        <div className={styles["jap-introcard-container-text"]}>
                            <h4>Smart Context</h4>
                            <p>
                                JokerAi SmartContext will auto-update when the user sends a
                                message to generate a better contextual answer.
                            </p>
                        </div>
                    </div>

                    <div className={styles["jap-introcard"]}>
                        <img className={styles["jap-introcard-image"]} src={AssetsPack.images.JAP_INTRO_CARD_02.main.default} alt="" />
                        <div className={styles["jap-introcard-container-text"]}>
                            <h4>Previous Messages</h4>
                            <p>
                                You can view and use previous generated responses by scrolling
                                up, selecting the message to use.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OnboardingCard;